// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__WH111","footer":"ModalCreateQualiphyProcedure_footer__1Pdvd","additionData":"ModalCreateQualiphyProcedure_additionData__TsZdK"};